import React from 'react'

import Field from '@utilities/Field'
import { EllipsisLoader } from '@components/Loaders'
import AreaSearchInput from '@components/AreaSearchInput'
import { ISearch, ISearchDispatchers } from '@managers/SearchableSelectList'

import theme from './searchableSelectStyle.module.scss'
import FieldContainer from './FieldContainer'

interface IProps {
  searchForArea: (v: any) => any
  locationSearch: ISearch
  locationSearchDispatchers: ISearchDispatchers
}

class LocationField extends Field<IProps> {
  displayName = 'LocationField'

  handleChange(locationId: string | null) {
    const { name, locationSearch } = this.props
    if (!locationId) {
      // Default back to input field value (eg. for full postcode)
      locationId = locationSearch.searchValue
    }
    this.props.onChange(name, locationId)
  }

  render() {
    const { autoComplete, field, name, info, icon, label, optional } = this.props
    let className = 'Input'

    return (
      <FieldContainer field={field} info={info} icon={icon} label={label} optional={optional}>
        <AreaSearchInput
          autoComplete={autoComplete}
          theme={theme}
          id={name}
          name={name}
          className={className}
          placeholder={this.props.placeholder}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          loader={<EllipsisLoader />}
          searchForArea={this.props.searchForArea}
          {...this.props.locationSearch}
          {...this.props.locationSearchDispatchers}
        />
      </FieldContainer>
    )
  }
}

export default LocationField
